import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-health-facilities',
    templateUrl: './health-facilities.component.html',
    styleUrls: ['./health-facilities.component.scss']
})
export class HealthFacilitiesComponent implements OnInit {
    src: string = '/assets/pdf/Medical facility.pdf';
    title: string = 'Health Facilities';

    constructor() { }

    ngOnInit(): void {
    }

}
